import { Component, ViewEncapsulation, Input, OnInit, ViewChild } from '@angular/core';
import { UploadFileService } from '../uploadfile.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, NgForm, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelperService } from '../../core/helper';
import * as XLSX from 'xlsx';
@Component({
    selector: 'app-uploadnewfile-screen',
    templateUrl: './uploadnewfile.screen.component.html',
    styleUrls: ['./uploadnewfile.screen.component.scss'],
    providers: [
        UploadFileService
    ],
    standalone: false
})

export class UploadNewFileScreenComponent implements OnInit {
   @ViewChild('f', { static: false }) floatingLabelForm: NgForm;
   // @ViewChild('vform', { static: false }) validationForm: FormGroup;
   // regularForm: FormGroup;
   manufacturers: Array<any>;
   selectedManufacturer: number;
   selectedMonthYear: String;
   note: String;
   formValidationList: any;
   addNewManufacturer: string;


   filetoupload: Array<File>;
   constructor(
      private _uploadFileService: UploadFileService,
      private _router: Router,
      private spinner: NgxSpinnerService,
      private _helper: HelperService,
      public activeModal: NgbActiveModal) {

      this.manufacturers = [];

      this.note = '';
      this.addNewManufacturer = '';
      this.filetoupload = [];
      this.selectedMonthYear = null;
      this.formValidationList = { 'manufacturers': '', 'filetoupload': '', 'addNewManufacturer': '' };
      // this.regularForm = new FormGroup({
      //    'note': new FormControl(null, []),
      //    'filetoupload': new FormControl(null, [Validators.required]),
      //    'manufacturers': new FormControl(0, [Validators.required]),
      // }, { updateOn: "change" });
   }
   ngOnInit() {
      this.selectedMonthYear = localStorage.getItem('selectedMonthYearLocalStorageUpload');
      this.spinner.show();
      this.selectedManufacturer = 0;
      const filter = ['Manufacturer'];
      const manufacturersTemp = [];
      const currentDate = this._helper.getCurrentDate();
      this._uploadFileService.getMasterData(filter).subscribe(
         (data) => {
            for (let loopIndex = 0; loopIndex < data.manufacturerData.length; loopIndex++) {
               if (!data.manufacturerData[loopIndex].deleteEffectiveDate) {
                 manufacturersTemp.push(data.manufacturerData[loopIndex]);
               } else {
                  if (currentDate < data.manufacturerData[loopIndex].deleteEffectiveDate) {
                     manufacturersTemp.push(data.manufacturerData[loopIndex]);
                  }
               }
             }            
            this.manufacturers = manufacturersTemp;
            this.spinner.hide();
         },
         error => console.log(error)
      )
   }

fileChangeEvent(fileInput: any) {
  const file = fileInput.target.files[0];
  if (!file) return;

  const fileName = file.name.toLowerCase();

  if (fileName.endsWith('.csv')) {
    // Handle CSV
    const reader = new FileReader();

    reader.onload = (e: any) => {
      let csvContent = e.target.result;

      console.log('CSV Before Cleaning:', csvContent);

      // Remove special characters
      const cleanedCSV = csvContent.replace(/[^\x20-\x7E\r\n\t]/g, '');

      console.log('CSV After Cleaning:', cleanedCSV);

      // Create new cleaned File object
      const cleanedFile = new File([cleanedCSV], file.name, {
        type: file.type
      });

      this.filetoupload = [cleanedFile];
      this.validateForm();
    };

    reader.readAsText(file);
  } else if (fileName.endsWith('.xlsx')) {
    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, {
        type: 'array',
        cellDates: true
      });

      const cleanedSheets: { [sheetName: string]: any[][] } = {};

      workbook.SheetNames.forEach(sheetName => {
        const sheet = workbook.Sheets[sheetName];

        // Get raw data, row-by-row
        const sheetData = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: false // get formatted text from Excel
        }) as any[][];

        if (!sheetData.length) {
          cleanedSheets[sheetName] = sheetData;
          return;
        }

        // ---------- 1) Detect date columns by header ----------
        const headerRow = sheetData[0] as string[];
        const dateCols = new Set<number>();

        headerRow.forEach((header, idx) => {
          if (typeof header === 'string' && /date/i.test(header)) {
            // any header containing "date"
            dateCols.add(idx); // e.g. crediting_date, load_date, Procedure Date
          }
        });

        // ---------- 2) Clean rows ----------
        const cleanedData = sheetData.map((row: any[], rowIndex: number) => {
          if (rowIndex === 0) return row; // header row

          return row.map((cell: any, colIndex: number) => {
            let value: any = cell;

            // --- only touch cells in date columns ---
         

          if (dateCols.has(colIndex)) {

            // If Excel already gives Date object
            if (cell instanceof Date && !isNaN(cell.getTime())) {
              const y = cell.getFullYear();
              const m = ('0' + (cell.getMonth() + 1)).slice(-2);
              const d = ('0' + cell.getDate()).slice(-2);
              value = `${y}-${m}-${d}`;
            }

            // If value is number (Excel serial date)
            else if (typeof cell === 'number' && cell > 25569) {
              value = this.convertExcelDate(cell);
            }

            // If value is string date
            else if (typeof cell === 'string') {
              const d = new Date(cell);
                if (!isNaN(d.getTime())) {
                  const y = d.getFullYear();
                  const m = ('0' + (d.getMonth() + 1)).slice(-2);
                  const day = ('0' + d.getDate()).slice(-2);
                  value = `${y}-${m}-${day}`;
                } else {
                  value = cell; // keep original
                }
            }
          }


            // clean strange characters in all text cells
            if (typeof value === 'string') {
              value = value.replace(/[^\x20-\x7E\r\n\t]/g, '');
            }

            return value;
          });
        });
        console.log('Cleaned Excel Data::::', cleanedData);
        cleanedSheets[sheetName] = cleanedData;
      });

      // ---------- 3) Rebuild workbook & file ----------
      const newWorkbook = XLSX.utils.book_new();
      for (const sheetName in cleanedSheets) {
        const worksheet = XLSX.utils.aoa_to_sheet(cleanedSheets[sheetName]);
        XLSX.utils.book_append_sheet(newWorkbook, worksheet, sheetName);
      }

      const arrayBuffer = XLSX.write(newWorkbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const cleanedBlob = new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const cleanedFile = new File([cleanedBlob], file.name, {
        type: file.type
      });

      this.filetoupload = [cleanedFile];
      console.log('this.filetoupload[][]', this.filetoupload);
      this.validateForm();
    };

    reader.readAsArrayBuffer(file);
  } else {
    console.warn('Unsupported file type');
  }
}


convertExcelDate(serial: number): string {
  if (!serial || isNaN(serial)) return '';

  const utcDays = Math.floor(serial - 25569);
  const utcValue = utcDays * 86400;
  const date = new Date(utcValue * 1000);

  if (isNaN(date.getTime())) return '';

  const y = date.getUTCFullYear();
  const m = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const d = ('0' + date.getUTCDate()).slice(-2);

  return `${y}-${m}-${d}`;
}


   validateForm() {

      let isValid = true;
      this.formValidationList.manufacturers = "";
      this.formValidationList.addNewManufacturer = "";
      if (this.selectedManufacturer == 0) {
         this.formValidationList.manufacturers = "This field is required!";
         isValid = false;
      } else if (this.selectedManufacturer == -1 && this.addNewManufacturer.trim() == "") {
         this.formValidationList.addNewManufacturer = "This field is required!";
         isValid = false;
      } else if (this.selectedManufacturer > 0) {
         this.addNewManufacturer = '';
      }
      this.formValidationList.filetoupload = "";
      if (this.filetoupload.length == 0) {
         this.formValidationList.filetoupload = "This field is required!";
         isValid = false;
      } else {
         const validFileExtension = ['xlsx', 'csv', 'xls'];
         const fileName = this.filetoupload[0].name;
         const fileExtension = fileName.split('.').pop();
         if (!validFileExtension.includes(fileExtension)) {
            this.formValidationList.filetoupload = "Invalid file extension!";
            isValid = false;
         }
      }
      return isValid;
   }
   submitForm() {
      console.log("call")
      if (this.validateForm()) {
         this.spinner.show();
         const params = {
            'note': this.note,
            'manufacturerId': this.selectedManufacturer,
            'selectedMonthYear': this.selectedMonthYear,
            'addNewManufacturer': this.addNewManufacturer.trim(),
         };
         this._uploadFileService.submitUploadForm(params, this.filetoupload).then(
            (data) => {
               this.spinner.hide();
               this.closePopup();
            },
            (error) => {
               this.spinner.hide();
               this.closePopup();
            }
         )
      }
   }
   closePopup() {
      this.activeModal.close('Close click');
   }
}
